<div class="row d-none" *ngIf="isToRedirect && paymentLight">
  <p class="mb-2">{{ 'COUNTER_REDIRECT.Text' | translate }}</p>
</div>
